import { UserDetails } from './../../models/userDetail.model';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ManageUsersService } from 'src/app/modules/manage-users/services/manage-users.service';
import { AFFILIATION, TRAINING, UPLOADS } from '../../constants/constant';

@Component({
  selector: 'app-view-user-profile',
  templateUrl: './view-user-profile.component.html',
  styleUrls: ['./view-user-profile.component.scss']
})
export class ViewUserProfileComponent implements OnInit {
  public backNavigation;
  public submitUserForm: any;
  public math = Math;
  public tabs = [
    { name: AFFILIATION, disable: false, url: AFFILIATION },
    { name: TRAINING, disable: false, url: TRAINING },
    { name: UPLOADS, disable: false, url: UPLOADS },
  ];
  public displayName: string;
  public updatedByObj: any = {};

  constructor(private route: ActivatedRoute, private router: Router, private manageUsersService: ManageUsersService) {
    const users: UserDetails[] = JSON.parse(sessionStorage.getItem('ALL_USERS'));
    this.route.params.subscribe(params => {
      const index = users && users.findIndex((x) => x.loginID == params.id);
      console.log(params.id);
      if (params.id) {
          this.manageUsersService.getUser(params.id).subscribe((user: UserDetails) => {
            this.displayName = user.displayName;
          }, (error) => {
          });
          }
    });
    this.manageUsersService.updateUserProfileUpdateStr.subscribe((response: any) => {
      if (response && response.updatedOn) {
        this.updatedByObj.updatedOn = response.updatedOn;
        this.updatedByObj.updatedBy = response.updatedBy;
      } else {
        this.updatedByObj = {};
      }
    });
    this.manageUsersService.updateTabs.subscribe((response: UserDetails) => {
      if (response && response.updatedOn) {
        this.updatedByObj.updatedOn = response.updatedOn;
        this.updatedByObj.updatedBy = response.updatedBy;
      }
      this.onTabSelection(this.getSelectedTabURL());
    });
   }

  ngOnInit(): void {
    this.backNavigation = this.router.url.substr(1, this.router.url.indexOf('/user')).slice(0, -1);
  }

  onTabSelection(tab): void {
      this.router.navigate([tab.url], { relativeTo: this.route });
  }

  getSelectedTab(): string {
    const selectedTab = this.tabs.findIndex((x) => this.router.url.indexOf(x.url) > -1);
    if (this.tabs[selectedTab]) {
      return this.tabs[selectedTab].name;
    }
    return '';
  }

  getSelectedTabURL(): any {
    const selectedTab = this.tabs.findIndex((x) => this.router.url.indexOf(x.url) > -1);
    return this.tabs[selectedTab];
  }

}
